import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=16f0ea60&scoped=true&"
import script from "./FeatureList.vue?vue&type=script&lang=js&"
export * from "./FeatureList.vue?vue&type=script&lang=js&"
import style0 from "./FeatureList.scss?vue&type=style&index=0&id=16f0ea60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f0ea60",
  null
  
)

export default component.exports